(() => {
  "use strict";

const SELECTORS = {
  section: ".emp-product-page",
  slides: ".emp-product-gallery__slide",
  thumbs: ".emp-product-gallery__thumb",
  dots: ".emp-product-gallery__dot",
  previous: ".emp-gallery-arrow--prev",
  next: ".emp-gallery-arrow--next",
  counter: ".emp-gallery-current",
  totalCounter: ".emp-gallery-total",
  gallery: ".emp-product-gallery",
  info: ".emp-product-info",
  galleryMain: ".emp-product-gallery__main",

  variantInput: "[data-variant-id]",
  price: "[data-product-price]",
  comparePrice: "[data-product-compare-price]",
  addButton: "[data-add-to-cart]",
  addButtonText: "[data-add-to-cart-text]",
  buyNow: "[data-buy-now]",
  variants: "[data-product-variants]",
  optionButtons: ".emp-product-option__value",
  optionLabels: "[data-selected-option]",
};

  const SHOPIFY_ROOT =
    window.Shopify?.routes?.root || "/";

  /* =========================================================
     MONEY
  ========================================================= */

  function formatMoney(cents) {
    if (
      cents === undefined ||
      cents === null ||
      cents === ""
    ) {
      return "";
    }

    const amount = Number(cents);

    if (Number.isNaN(amount)) {
      return "";
    }

    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === "function"
    ) {
      try {
        return window.Shopify.formatMoney(
          amount,
          window.Shopify.money_format
        );
      } catch (error) {
        console.warn(
          "[Empureo] Money formatter failed:",
          error
        );
      }
    }

    return `£${(amount / 100).toFixed(2)}`;
  }

  /* =========================================================
     VALUE NORMALIZATION
  ========================================================= */

  function normalizeValue(value) {
    if (
      value === undefined ||
      value === null
    ) {
      return "";
    }

    return String(value)
      .trim()
      .toLowerCase();
  }

  /* =========================================================
     PRODUCT INITIALIZATION
  ========================================================= */

  function initEmpProduct(section) {
    if (!section) return;

    if (
      section.dataset.empInitialized === "true"
    ) {
      return;
    }

    section.dataset.empInitialized = "true";

    /* =======================================================
       GALLERY
    ======================================================= */

    const slides = Array.from(
      section.querySelectorAll(
        SELECTORS.slides
      )
    );

    const thumbs = Array.from(
      section.querySelectorAll(
        SELECTORS.thumbs
      )
    );
    const dots = Array.from(
  section.querySelectorAll(
    SELECTORS.dots
  )
);

    const previous =
      section.querySelector(
        SELECTORS.previous
      );

    const next =
      section.querySelector(
        SELECTORS.next
      );

    const counter =
      section.querySelector(
        SELECTORS.counter
      );

    const totalCounter =
      section.querySelector(
        SELECTORS.totalCounter
      );

    const galleryMain =
      section.querySelector(
        SELECTORS.galleryMain
      );

    let currentIndex = 0;
    let touchStartX = 0;

    function showSlide(index) {
      if (!slides.length) {
        return;
      }

      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      currentIndex = index;

      slides.forEach(
        (slide, slideIndex) => {
          slide.classList.toggle(
            "active",
            slideIndex === currentIndex
          );
        }
      );

      thumbs.forEach(
        (thumb, thumbIndex) => {
          thumb.classList.toggle(
            "active",
            thumbIndex === currentIndex
          );
        }
      );
      dots.forEach(
  (dot, dotIndex) => {
    const isActive =
      dotIndex === currentIndex;

    dot.classList.toggle(
      "active",
      isActive
    );

    dot.setAttribute(
      "aria-current",
      isActive
        ? "true"
        : "false"
    );
  }
);

      if (counter) {
        counter.textContent =
          String(currentIndex + 1).padStart(
            2,
            "0"
          );
      }

      if (totalCounter) {
        totalCounter.textContent =
          String(slides.length).padStart(
            2,
            "0"
          );
      }

      const activeThumb =
        thumbs[currentIndex];

      if (activeThumb) {
        activeThumb.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        });
      }
    }

    /* =======================================================
       GALLERY / INFO HEIGHT
       LEFT SIDE DEFINES THE HEIGHT.
       RIGHT SIDE MATCHES THAT HEIGHT.
       ======================================================= */

function syncInfoHeight() {
  const grid =
    section.querySelector(
      ".emp-product-grid"
    );

  const galleryColumn =
    section.querySelector(
      SELECTORS.gallery
    );

  const infoColumn =
    section.querySelector(
      SELECTORS.info
    );

  if (
    !grid ||
    !galleryColumn ||
    !infoColumn
  ) {
    return;
  }


  /* =====================================================
     DESKTOP
     ===================================================== */

  if (window.innerWidth > 1100) {

    /*
     * STEP 1
     * Remove the OLD grid height first.
     *
     * This is the part your current version is missing.
     */
    grid.style.setProperty(
      "height",
      "auto",
      "important"
    );

    grid.style.setProperty(
      "min-height",
      "0",
      "important"
    );

    /*
     * Do NOT let the grid stretch the gallery
     * while measuring it.
     */
    grid.style.setProperty(
      "align-items",
      "start",
      "important"
    );


    /*
     * LEFT = natural height.
     */
    galleryColumn.style.setProperty(
      "height",
      "auto",
      "important"
    );

    galleryColumn.style.setProperty(
      "min-height",
      "0",
      "important"
    );

    galleryColumn.style.setProperty(
      "max-height",
      "none",
      "important"
    );

    galleryColumn.style.setProperty(
      "overflow",
      "visible",
      "important"
    );


    /*
     * STEP 2
     * Completely remove RIGHT from the layout
     * while measuring LEFT.
     */
    const previousDisplay =
      infoColumn.style.display;

    infoColumn.style.setProperty(
      "display",
      "none",
      "important"
    );


    /*
     * Force browser to calculate the
     * gallery's real natural height.
     */
    void galleryColumn.offsetHeight;


    const leftHeight =
      galleryColumn.offsetHeight;


    /*
     * Restore RIGHT.
     */
    if (previousDisplay) {

      infoColumn.style.display =
        previousDisplay;

    } else {

      infoColumn.style.removeProperty(
        "display"
      );
    }


    /*
     * STEP 3
     * The entire product grid now has
     * exactly the LEFT height.
     */
    grid.style.setProperty(
      "height",
      `${leftHeight}px`,
      "important"
    );

    grid.style.setProperty(
      "align-items",
      "stretch",
      "important"
    );


    /*
     * LEFT remains visible and normal.
     */
    galleryColumn.style.setProperty(
      "height",
      `${leftHeight}px`,
      "important"
    );

    galleryColumn.style.setProperty(
      "overflow",
      "visible",
      "important"
    );


    /*
     * STEP 4
     * RIGHT gets exactly the LEFT height.
     */
    infoColumn.style.setProperty(
      "height",
      `${leftHeight}px`,
      "important"
    );

    infoColumn.style.setProperty(
      "max-height",
      `${leftHeight}px`,
      "important"
    );

    infoColumn.style.setProperty(
      "min-height",
      "0",
      "important"
    );

    infoColumn.style.setProperty(
      "overflow-y",
      "auto",
      "important"
    );

    infoColumn.style.setProperty(
      "overflow-x",
      "hidden",
      "important"
    );


    /*
     * Allow page scrolling to continue
     * when RIGHT reaches its boundary.
     */
    infoColumn.style.setProperty(
      "overscroll-behavior-y",
      "auto",
      "important"
    );


    /*
     * DO NOT SHOW SCROLLBAR.
     */
    infoColumn.style.setProperty(
      "scrollbar-width",
      "none",
      "important"
    );

    infoColumn.style.setProperty(
      "-ms-overflow-style",
      "none",
      "important"
    );


  } else {

    /* =====================================================
       MOBILE / TABLET
       ===================================================== */

    grid.style.removeProperty(
      "height"
    );

    grid.style.removeProperty(
      "min-height"
    );

    grid.style.removeProperty(
      "align-items"
    );


    galleryColumn.style.removeProperty(
      "height"
    );

    galleryColumn.style.removeProperty(
      "min-height"
    );

    galleryColumn.style.removeProperty(
      "max-height"
    );

    galleryColumn.style.removeProperty(
      "overflow"
    );


    infoColumn.style.removeProperty(
      "height"
    );

    infoColumn.style.removeProperty(
      "max-height"
    );

    infoColumn.style.removeProperty(
      "min-height"
    );

    infoColumn.style.removeProperty(
      "overflow"
    );

    infoColumn.style.removeProperty(
      "overflow-y"
    );

    infoColumn.style.removeProperty(
      "overflow-x"
    );

    infoColumn.style.removeProperty(
      "overscroll-behavior-y"
    );

    infoColumn.style.removeProperty(
      "scrollbar-width"
    );

    infoColumn.style.removeProperty(
      "-ms-overflow-style"
    );
  }
}

    /* =======================================================
       ISSUE 19 — RIGHT SIDE IS THE ONLY INTERNAL SCROLLER
       ======================================================= */

    function hideProductInfoScrollbar() {
      if (
        document.getElementById(
          "emp-product-info-scrollbar-style"
        )
      ) {
        return;
      }

      const style =
        document.createElement("style");

      style.id =
        "emp-product-info-scrollbar-style";

      style.textContent = `
        @media screen and (min-width: 1101px) {
          .emp-product-info {
            scrollbar-width: none !important;
            -ms-overflow-style: none !important;
          }

          .emp-product-info::-webkit-scrollbar {
            display: none !important;
            width: 0 !important;
            height: 0 !important;
          }
        }
      `;

      document.head.appendChild(style);
    }

function setupRightSideScroll() {
  const grid =
    section.querySelector(
      ".emp-product-grid"
    );

  const info =
    section.querySelector(
      SELECTORS.info
    );

  if (!grid || !info) {
    return;
  }

  /*
   * Remove previous listener if Shopify
   * reinitializes the section.
   */
  if (section._empRightScrollCleanup) {
    section._empRightScrollCleanup();
  }


  function getWheelDelta(event) {
    if (event.deltaMode === 1) {
      return event.deltaY * 16;
    }

    if (event.deltaMode === 2) {
      return event.deltaY * window.innerHeight;
    }

    return event.deltaY;
  }


  function handleWheel(event) {
    /*
     * Desktop only.
     */
    if (window.innerWidth <= 1100) {
      return;
    }


    /*
     * Ignore horizontal-only trackpad gestures.
     */
    if (
      Math.abs(event.deltaY) <=
      Math.abs(event.deltaX)
    ) {
      return;
    }


    /*
     * -----------------------------------------------------
     * RIGHT SIDE
     * -----------------------------------------------------
     *
     * Let Chrome handle the RIGHT column natively.
     *
     * This keeps scrolling smooth and removes lag.
     */
    if (info.contains(event.target)) {
      return;
    }


    /*
     * -----------------------------------------------------
     * LEFT / GALLERY / GAP
     * -----------------------------------------------------
     *
     * Anything else inside the product grid
     * controls the RIGHT column.
     */
    const delta =
      getWheelDelta(event);

    if (!delta) {
      return;
    }


    const maxScroll =
      Math.max(
        0,
        info.scrollHeight -
        info.clientHeight
      );


    /*
     * RIGHT content is not actually longer.
     *
     * Let the page scroll normally.
     */
    if (maxScroll <= 1) {
      return;
    }


    const current =
      info.scrollTop;


    /*
     * Scrolling UP while RIGHT is already
     * at the top -> give control back to page.
     */
    if (
      delta < 0 &&
      current <= 0
    ) {
      return;
    }


    /*
     * Scrolling DOWN while RIGHT is already
     * at the bottom -> give control back to page.
     */
    if (
      delta > 0 &&
      current >= maxScroll
    ) {
      return;
    }


    /*
     * Move RIGHT directly.
     *
     * No smooth animation here because wheel
     * events are already continuous. Smooth
     * scrolling causes lag.
     */
    const next =
      Math.max(
        0,
        Math.min(
          maxScroll,
          current + delta
        )
      );


    info.scrollTop =
      next;


    /*
     * Prevent the LEFT/GALLERY/page from
     * consuming this wheel movement.
     */
    event.preventDefault();
  }


  /*
   * CAPTURE PHASE
   *
   * This is the important change.
   *
   * The grid catches the wheel event before
   * child elements can interfere with it.
   */
  grid.addEventListener(
    "wheel",
    handleWheel,
    {
      passive: false,
      capture: true
    }
  );


  section._empRightScrollCleanup = () => {
    grid.removeEventListener(
      "wheel",
      handleWheel,
      {
        capture: true
      }
    );
  };
}

    /* =======================================================
       GALLERY BUTTONS
    ======================================================= */

    previous?.addEventListener(
      "click",
      (event) => {
        event.preventDefault();

        showSlide(
          currentIndex - 1
        );
      }
    );

    next?.addEventListener(
      "click",
      (event) => {
        event.preventDefault();

        showSlide(
          currentIndex + 1
        );
      }
    );

    /* =======================================================
       THUMBNAILS
    ======================================================= */

    thumbs.forEach((thumb) => {
      thumb.addEventListener(
        "click",
        (event) => {
          event.preventDefault();

          const index = Number(
            thumb.dataset.index
          );

          if (!Number.isNaN(index)) {
            showSlide(index);
          }
        }
      );
    });
    dots.forEach((dot) => {
  dot.addEventListener(
    "click",
    (event) => {
      event.preventDefault();

      const index = Number(
        dot.dataset.index
      );

      if (!Number.isNaN(index)) {
        showSlide(index);
      }
    }
  );
});
/* =======================================================
   THUMBNAILS — HORIZONTAL SCROLL
======================================================= */

function setupThumbnailScrolling() {
  const thumbsContainer =
    section.querySelector(
      ".emp-product-gallery__thumbs"
    );

  if (!thumbsContainer) {
    return;
  }

  /*
   * Mouse wheel / trackpad
   * Vertical wheel becomes horizontal movement.
   */
  thumbsContainer.addEventListener(
    "wheel",
    (event) => {

      if (
        thumbsContainer.scrollWidth <=
        thumbsContainer.clientWidth
      ) {
        return;
      }

      const amount =
        Math.abs(event.deltaY) >
        Math.abs(event.deltaX)
          ? event.deltaY
          : event.deltaX;

      if (!amount) {
        return;
      }

      event.preventDefault();

      thumbsContainer.scrollLeft += amount;
    },
    {
      passive: false
    }
  );


  /*
   * Drag with mouse.
   */
  let isDragging = false;
  let startX = 0;
  let startScrollLeft = 0;

  thumbsContainer.addEventListener(
    "mousedown",
    (event) => {

      if (event.button !== 0) {
        return;
      }

      isDragging = true;

      startX =
        event.pageX -
        thumbsContainer.offsetLeft;

      startScrollLeft =
        thumbsContainer.scrollLeft;

      thumbsContainer.style.cursor =
        "grabbing";

      thumbsContainer.style.userSelect =
        "none";
    }
  );


  thumbsContainer.addEventListener(
    "mousemove",
    (event) => {

      if (!isDragging) {
        return;
      }

      event.preventDefault();

      const x =
        event.pageX -
        thumbsContainer.offsetLeft;

      const distance =
        (x - startX) * 1.2;

      thumbsContainer.scrollLeft =
        startScrollLeft - distance;
    }
  );


  function stopDragging() {
    isDragging = false;

    thumbsContainer.style.cursor =
      "";

    thumbsContainer.style.userSelect =
      "";
  }

  thumbsContainer.addEventListener(
    "mouseup",
    stopDragging
  );

  thumbsContainer.addEventListener(
    "mouseleave",
    stopDragging
  );
}

    /* =======================================================
       TOUCH / SWIPE
    ======================================================= */

    galleryMain?.addEventListener(
      "touchstart",
      (event) => {
        if (!event.touches.length) {
          return;
        }

        touchStartX =
          event.touches[0].clientX;
      },
      {
        passive: true,
      }
    );

    galleryMain?.addEventListener(
      "touchend",
      (event) => {
        if (
          !event.changedTouches.length
        ) {
          return;
        }

        const touchEndX =
          event.changedTouches[0].clientX;

        const difference =
          touchStartX - touchEndX;

        const minimumSwipeDistance = 50;

        if (
          Math.abs(difference) <
          minimumSwipeDistance
        ) {
          return;
        }

        if (difference > 0) {
          showSlide(
            currentIndex + 1
          );
        } else {
          showSlide(
            currentIndex - 1
          );
        }
      },
      {
        passive: true,
      }
    );

  hideProductInfoScrollbar();

syncInfoHeight();

setupRightSideScroll();
const galleryResizeObserver =
  new ResizeObserver(() => {
    syncInfoHeight();
  });

const galleryForObserver =
  section.querySelector(
    SELECTORS.gallery
  );

if (galleryForObserver) {
  galleryResizeObserver.observe(
    galleryForObserver
  );
}

section._empGalleryResizeObserver =
  galleryResizeObserver;

setupThumbnailScrolling();
    window.addEventListener(
      "resize",
      syncInfoHeight
    );

    window.addEventListener(
      "load",
      () => {
        syncInfoHeight();
        // setupRightSideScroll();
      }
    );
        /* =======================================================
       VARIANT ELEMENTS
    ======================================================= */

    const variantInput =
      section.querySelector(
        SELECTORS.variantInput
      );

    const priceElement =
      section.querySelector(
        SELECTORS.price
      );

    const comparePriceElement =
      section.querySelector(
        SELECTORS.comparePrice
      );

    const addButton =
      section.querySelector(
        SELECTORS.addButton
      );

    const addButtonText =
      section.querySelector(
        SELECTORS.addButtonText
      );

    const buyNowButton =
      section.querySelector(
        SELECTORS.buyNow
      );

    const variantsElement =
      section.querySelector(
        SELECTORS.variants
      );

    const optionButtons =
      Array.from(
        section.querySelectorAll(
          SELECTORS.optionButtons
        )
      );

    const optionLabels =
      Array.from(
        section.querySelectorAll(
          SELECTORS.optionLabels
        )
      );

    /* =======================================================
       READ VARIANTS
    ======================================================= */

    let variants = [];
    let selectedOptions = [];

    if (variantsElement) {
      try {
        const parsed =
          JSON.parse(
            variantsElement.textContent.trim()
          );

        if (Array.isArray(parsed)) {
          variants = parsed;
        }
      } catch (error) {
        console.error(
          "[Empureo] Unable to read variants:",
          error
        );
      }
    }

    /* =======================================================
       INITIAL SELECTED OPTIONS
    ======================================================= */

    optionButtons.forEach(
      (button) => {
        if (
          !button.classList.contains(
            "active"
          )
        ) {
          return;
        }

        const position =
          Number(
            button.dataset.optionPosition
          );

        const value =
          button.dataset.optionValue;

        if (
          !Number.isNaN(position) &&
          value !== undefined
        ) {
          selectedOptions[position] =
            value;
        }
      }
    );

    /* =======================================================
       FIND VARIANT
    ======================================================= */

    function findVariant() {
      if (!variants.length) {
        return null;
      }

      return (
        variants.find((variant) => {
          if (
            !variant ||
            !Array.isArray(
              variant.options
            )
          ) {
            return false;
          }

          return variant.options.every(
            (
              variantValue,
              index
            ) => {
              return (
                normalizeValue(
                  variantValue
                ) ===
                normalizeValue(
                  selectedOptions[index]
                )
              );
            }
          );
        }) || null
      );
    }

    /* =======================================================
       VARIANT MEDIA
    ======================================================= */

    function getVariantMediaId(
      variant
    ) {
      if (!variant) {
        return null;
      }

      if (
        variant.featured_media &&
        variant.featured_media.id
      ) {
        return variant.featured_media.id;
      }

      if (
        variant.featured_media_id
      ) {
        return variant.featured_media_id;
      }

      if (variant.image_id) {
        return variant.image_id;
      }

      if (
        variant.featured_image &&
        variant.featured_image.id
      ) {
        return variant.featured_image.id;
      }

      if (
        variant.featured_image_id
      ) {
        return variant.featured_image_id;
      }

      return null;
    }

    function changeGalleryToVariant(
      variant
    ) {
      const mediaId =
        getVariantMediaId(
          variant
        );

      if (!mediaId) {
        return;
      }

      const imageIndex =
        slides.findIndex(
          (slide) => {
            return (
              String(
                slide.dataset.mediaId
              ) ===
              String(mediaId)
            );
          }
        );

      if (imageIndex >= 0) {
        showSlide(imageIndex);
      }
    }

    /* =======================================================
       OPTION LABELS
    ======================================================= */

    function updateOptionLabels() {
      optionLabels.forEach(
        (label) => {
          const position =
            Number(
              label.dataset.selectedOption
            );

          if (
            !Number.isNaN(position) &&
            selectedOptions[position] !==
              undefined
          ) {
            label.textContent =
              selectedOptions[position];
          }
        }
      );
    }

    /* =======================================================
       ACTIVE OPTION BUTTONS
    ======================================================= */

    function updateActiveButtons() {
      optionButtons.forEach(
        (button) => {
          const position =
            Number(
              button.dataset.optionPosition
            );

          const value =
            button.dataset.optionValue;

          const isSelected =
            normalizeValue(
              selectedOptions[position]
            ) ===
            normalizeValue(value);

          button.classList.toggle(
            "active",
            isSelected
          );

          button.setAttribute(
            "aria-pressed",
            isSelected
              ? "true"
              : "false"
          );
        }
      );
    }

    /* =======================================================
       AVAILABILITY
    ======================================================= */

    function setAvailability(
      available,
      text
    ) {
      if (addButton) {
        addButton.disabled =
          !available;

        addButton.classList.toggle(
          "is-disabled",
          !available
        );
      }

      if (addButtonText) {
        addButtonText.textContent =
          text;
      }

      if (buyNowButton) {
        buyNowButton.disabled =
          !available;

        buyNowButton.classList.toggle(
          "is-disabled",
          !available
        );
      }
    }

    /* =======================================================
       UPDATE PRODUCT UI
    ======================================================= */

    function updateProductUI(
      variant
    ) {
      if (!variant) {
        return;
      }

      /* Variant ID */
      if (variantInput) {
        variantInput.value =
          variant.id || "";
      }

      /* Price */
      if (priceElement) {
        priceElement.textContent =
          formatMoney(
            variant.price
          );
      }

      /* Compare price */
      if (comparePriceElement) {
        const comparePrice =
          Number(
            variant.compare_at_price
          );

        const price =
          Number(
            variant.price
          );

        if (
          comparePrice &&
          comparePrice > price
        ) {
          comparePriceElement.textContent =
            formatMoney(
              comparePrice
            );

          comparePriceElement.hidden =
            false;
        } else {
          comparePriceElement.textContent =
            "";

          comparePriceElement.hidden =
            true;
        }
      }

      /* Availability */
      const available =
        Boolean(
          variant.available
        );

      setAvailability(
        available,
        available
          ? "ADD TO CART"
          : "SOLD OUT"
      );

      updateOptionLabels();
      updateActiveButtons();
      changeGalleryToVariant(
        variant
      );
    }

    /* =======================================================
       OPTION BUTTON CLICK
    ======================================================= */

    optionButtons.forEach(
      (button) => {
        button.addEventListener(
          "click",
          (event) => {
            event.preventDefault();

            const position =
              Number(
                button.dataset
                  .optionPosition
              );

            const value =
              button.dataset
                .optionValue;

            if (
              Number.isNaN(
                position
              ) ||
              value === undefined
            ) {
              return;
            }

            selectedOptions[position] =
              value;

            updateActiveButtons();

            const variant =
              findVariant();

            if (variant) {
              updateProductUI(
                variant
              );
            } else {
              setAvailability(
                false,
                "UNAVAILABLE"
              );
            }
          }
        );
      }
    );

    /* =======================================================
       KEYBOARD NAVIGATION
    ======================================================= */

    function keyboardHandler(event) {
      const target =
        event.target;

      if (
        target &&
        (
          target.tagName ===
            "INPUT" ||
          target.tagName ===
            "TEXTAREA" ||
          target.tagName ===
            "SELECT" ||
          target.isContentEditable
        )
      ) {
        return;
      }

      if (
        event.key ===
        "ArrowLeft"
      ) {
        event.preventDefault();

        showSlide(
          currentIndex - 1
        );
      }

      if (
        event.key ===
        "ArrowRight"
      ) {
        event.preventDefault();

        showSlide(
          currentIndex + 1
        );
      }
    }

    document.addEventListener(
      "keydown",
      keyboardHandler
    );

    /* =======================================================
       CART DRAWER
    ======================================================= */

    function openCartDrawerInstant() {
      const drawer =
        document.getElementById(
          "EmpCartDrawer"
        );

      if (!drawer) {
        console.error(
          "[Empureo] #EmpCartDrawer not found."
        );

        return false;
      }

      drawer.classList.add(
        "is-open"
      );

      drawer.setAttribute(
        "aria-hidden",
        "false"
      );

      document.documentElement.classList.add(
        "emp-cart-open"
      );

      document.body.classList.add(
        "emp-cart-open"
      );

      document
        .querySelectorAll(
          "[data-cart-drawer-open]"
        )
        .forEach(
          (trigger) => {
            trigger.setAttribute(
              "aria-expanded",
              "true"
            );
          }
        );

      return true;
    }

    function closeCartDrawer() {
      const drawer =
        document.getElementById(
          "EmpCartDrawer"
        );

      if (!drawer) {
        return;
      }

      drawer.classList.remove(
        "is-open"
      );

      drawer.setAttribute(
        "aria-hidden",
        "true"
      );

      document.documentElement.classList.remove(
        "emp-cart-open"
      );

      document.body.classList.remove(
        "emp-cart-open"
      );

      document
        .querySelectorAll(
          "[data-cart-drawer-open]"
        )
        .forEach(
          (trigger) => {
            trigger.setAttribute(
              "aria-expanded",
              "false"
            );
          }
        );
    }

    /* =======================================================
       REFRESH CART DRAWER
    ======================================================= */

    async function refreshCartDrawer() {
      try {
        const cartResponse =
          await fetch(
            `${SHOPIFY_ROOT}cart.js`,
            {
              method: "GET",
              headers: {
                Accept:
                  "application/json",
              },
              cache: "no-store",
            }
          );

        if (!cartResponse.ok) {
          return;
        }

        const cart =
          await cartResponse.json();

        /* Header cart count */
        document
          .querySelectorAll(
            ".emp-cart-count"
          )
          .forEach(
            (badge) => {
              const hasItems =
                cart.item_count > 0;

              badge.textContent =
                hasItems
                  ? cart.item_count
                  : "";

              badge.style.display =
                hasItems
                  ? ""
                  : "none";
            }
          );

        /* Mobile cart count */
        document
          .querySelectorAll(
            "[data-cart-count]"
          )
          .forEach(
            (element) => {
              element.textContent =
                cart.item_count > 0
                  ? `(${cart.item_count})`
                  : "";
            }
          );

        /* Get updated drawer */
        const pageResponse =
          await fetch(
            window.location.href,
            {
              method: "GET",
              headers: {
                "X-Requested-With":
                  "XMLHttpRequest",
              },
              cache: "no-store",
            }
          );

        if (!pageResponse.ok) {
          return;
        }

        const html =
          await pageResponse.text();

        const doc =
          new DOMParser()
            .parseFromString(
              html,
              "text/html"
            );

        const newDrawer =
          doc.querySelector(
            "#EmpCartDrawer"
          );

        const currentDrawer =
          document.querySelector(
            "#EmpCartDrawer"
          );

        if (
          newDrawer &&
          currentDrawer
        ) {
          currentDrawer.innerHTML =
            newDrawer.innerHTML;
        }
      } catch (error) {
        console.error(
          "[Empureo] Cart drawer refresh failed:",
          error
        );
      }
    }

    /* =======================================================
       PRODUCT FORM
    ======================================================= */

    const productForm =
      section.querySelector(
        'form[action*="/cart/add"]'
      );

    /* =======================================================
       ADD TO CART
    ======================================================= */

    if (productForm) {
      productForm.addEventListener(
        "submit",
        async (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (
            !addButton ||
            addButton.disabled
          ) {
            return;
          }

          if (
            productForm.dataset
              .addingToCart ===
            "true"
          ) {
            return;
          }

          productForm.dataset
            .addingToCart = "true";

          addButton.disabled = true;

          if (addButtonText) {
            addButtonText.textContent =
              "ADDING...";
          }

          try {
            const formData =
              new FormData(
                productForm
              );

            if (variantInput) {
              formData.set(
                "id",
                variantInput.value
              );
            }

            formData.set(
              "quantity",
              "1"
            );

            const response =
              await fetch(
                `${SHOPIFY_ROOT}cart/add.js`,
                {
                  method: "POST",
                  headers: {
                    Accept:
                      "application/json",

                    "X-Requested-With":
                      "XMLHttpRequest",
                  },
                  body: formData,
                }
              );

            const data =
              await response.json();

            if (!response.ok) {
              throw new Error(
                data.description ||
                data.message ||
                "Unable to add product to cart."
              );
            }

            if (addButtonText) {
              addButtonText.textContent =
                "ADDED";
            }

            await refreshCartDrawer();

            openCartDrawerInstant();
          } catch (error) {
            console.error(
              "[Empureo] Add to cart failed:",
              error
            );

            if (addButtonText) {
              addButtonText.textContent =
                "TRY AGAIN";
            }
          } finally {
            setTimeout(
              () => {
                productForm.dataset
                  .addingToCart =
                  "false";

                const currentVariant =
                  findVariant();

                const available =
                  currentVariant
                    ? Boolean(
                        currentVariant.available
                      )
                    : true;

                if (addButton) {
                  addButton.disabled =
                    !available;
                }

                if (addButtonText) {
                  addButtonText.textContent =
                    available
                      ? "ADD TO CART"
                      : "SOLD OUT";
                }
              },
              500
            );
          }
        }
      );
    }
        /* =======================================================
       BUY NOW
    ======================================================= */

    if (buyNowButton) {
      buyNowButton.addEventListener(
        "click",
        async (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (
            buyNowButton.disabled
          ) {
            return;
          }

          if (
            buyNowButton.dataset
              .buyingNow ===
            "true"
          ) {
            return;
          }

          const currentVariant =
            findVariant();

          if (
            !currentVariant ||
            !currentVariant.id ||
            !currentVariant.available
          ) {
            return;
          }

          buyNowButton.dataset
            .buyingNow = "true";

          const originalHTML =
            buyNowButton.innerHTML;

          buyNowButton.disabled =
            true;

          buyNowButton.innerHTML =
            "<span>CHECKOUT...</span>";

          try {
            const response =
              await fetch(
                `${SHOPIFY_ROOT}cart/add.js`,
                {
                  method: "POST",
                  headers: {
                    Accept:
                      "application/json",

                    "Content-Type":
                      "application/json",

                    "X-Requested-With":
                      "XMLHttpRequest",
                  },
                  body: JSON.stringify({
                    items: [
                      {
                        id: Number(
                          currentVariant.id
                        ),
                        quantity: 1,
                      },
                    ],
                  }),
                }
              );

            const data =
              await response.json();

            if (!response.ok) {
              throw new Error(
                data.description ||
                data.message ||
                "Unable to add product."
              );
            }

            window.location.href =
              `${SHOPIFY_ROOT}checkout`;
          } catch (error) {
            console.error(
              "[Empureo] Buy Now failed:",
              error
            );

            buyNowButton.disabled =
              false;

            buyNowButton.innerHTML =
              originalHTML;

            buyNowButton.dataset
              .buyingNow = "false";
          }
        }
      );
    }

    /* =======================================================
       INITIAL VARIANT
    ======================================================= */

    const initialVariant =
      findVariant();

    if (initialVariant) {
      updateProductUI(
        initialVariant
      );
    } else {
      const fallbackVariant =
        variants.find(
          (variant) =>
            variant.available
        ) ||
        variants[0];

      if (fallbackVariant) {
        if (
          Array.isArray(
            fallbackVariant.options
          )
        ) {
          fallbackVariant.options.forEach(
            (value, index) => {
              selectedOptions[index] =
                value;
            }
          );
        }

        updateProductUI(
          fallbackVariant
        );
      }
    }

    /* =======================================================
       INITIAL GALLERY
    ======================================================= */

    if (!initialVariant) {
      showSlide(0);
    }

    /* =======================================================
       CLEANUP
    ======================================================= */

    section._empProductCleanup =
      () => {
        document.removeEventListener(
          "keydown",
          keyboardHandler
        );

        window.removeEventListener(
          "resize",
          syncInfoHeight
        );

        window.removeEventListener(
          "load",
          syncInfoHeight
        );

        if (
          section._empRightScrollCleanup
        ) {
          section._empRightScrollCleanup();
        }
      };
  }

  /* =========================================================
     INITIALIZE ALL PRODUCT SECTIONS
  ========================================================= */

  function initAllEmpProducts() {
    document
      .querySelectorAll(
        SELECTORS.section
      )
      .forEach(
        (section) => {
          if (
            section.dataset
              .empInitialized !==
            "true"
          ) {
            initEmpProduct(
              section
            );
          }
        }
      );
  }

  /* =========================================================
     INITIAL PAGE LOAD
  ========================================================= */

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initAllEmpProducts,
      {
        once: true,
      }
    );
  } else {
    initAllEmpProducts();
  }

  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      const section =
        event.target.querySelector(
          SELECTORS.section
        );

      if (!section) {
        return;
      }

      section.dataset
        .empInitialized = "false";

      initEmpProduct(section);
    }
  );

  /* =========================================================
     SHOPIFY SECTION UNLOAD
  ========================================================= */

  document.addEventListener(
    "shopify:section:unload",
    (event) => {
      const section =
        event.target.querySelector(
          SELECTORS.section
        );

      if (
        section &&
        typeof section
          ._empProductCleanup ===
          "function"
      ) {
        section._empProductCleanup();
      }
    }
  );
})();

/* =========================================================
   DELIVERY COUNTDOWN
   ========================================================= */

(function () {
  'use strict';

  const DELIVERY_TIMEZONE = 'Europe/London';

  const WEEKDAYS = {
    sunday: 0,
    sun: 0,

    monday: 1,
    mon: 1,

    tuesday: 2,
    tue: 2,
    tues: 2,

    wednesday: 3,
    wed: 3,

    thursday: 4,
    thu: 4,
    thurs: 4,

    friday: 5,
    fri: 5,

    saturday: 6,
    sat: 6
  };

  function getLondonDateParts() {
    const now = new Date();

    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: DELIVERY_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'long',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(now);

    const result = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') {
        result[part.type] = part.value;
      }
    });

    return {
      year: Number(result.year),
      month: Number(result.month),
      day: Number(result.day),
      weekday: WEEKDAYS[(result.weekday || '').toLowerCase()],
      hour: Number(result.hour),
      minute: Number(result.minute),
      second: Number(result.second)
    };
  }

  function getLondonTimeZoneOffset(date) {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: DELIVERY_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(date);

    const values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') {
        values[part.type] = Number(part.value);
      }
    });

    const utcTime = Date.UTC(
      values.year,
      values.month - 1,
      values.day,
      values.hour,
      values.minute,
      values.second
    );

    return utcTime - date.getTime();
  }

  function londonDateToTimestamp(year, month, day, hour, minute, second) {
    const approximateUTC = Date.UTC(
      year,
      month - 1,
      day,
      hour,
      minute,
      second
    );

    const offset = getLondonTimeZoneOffset(
      new Date(approximateUTC)
    );

    return approximateUTC - offset;
  }

  function getNextDeliveryDate(deliveryDay, cutoffHour, cutoffMinute) {
    const normalizedDay = deliveryDay
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');

    const targetWeekday = WEEKDAYS[normalizedDay];

    if (targetWeekday === undefined) {
      return null;
    }

    const now = getLondonDateParts();

    let daysUntil = targetWeekday - now.weekday;

    if (daysUntil < 0) {
      daysUntil += 7;
    }

    /*
     * If delivery day is today but the 5 PM cutoff
     * has already passed, use next week's delivery day.
     */
    if (
      daysUntil === 0 &&
      (
        now.hour > cutoffHour ||
        (
          now.hour === cutoffHour &&
          now.minute >= cutoffMinute
        )
      )
    ) {
      daysUntil = 7;
    }

    const date = new Date(
      Date.UTC(
        now.year,
        now.month - 1,
        now.day + daysUntil,
        0,
        0,
        0
      )
    );

    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate(),
      timestamp: londonDateToTimestamp(
        date.getUTCFullYear(),
        date.getUTCMonth() + 1,
        date.getUTCDate(),
        cutoffHour,
        cutoffMinute,
        0
      )
    };
  }

  function formatCountdown(milliseconds) {
    if (milliseconds <= 0) {
      return '00h 00m 00s';
    }

    const totalSeconds = Math.floor(milliseconds / 1000);

    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor(
      (totalSeconds % 86400) / 3600
    );
    const minutes = Math.floor(
      (totalSeconds % 3600) / 60
    );
    const seconds = totalSeconds % 60;

    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');
    const paddedSeconds = String(seconds).padStart(2, '0');

    if (days > 0) {
      return (
        days +
        'd ' +
        paddedHours +
        'h ' +
        paddedMinutes +
        'm'
      );
    }

    return (
      paddedHours +
      'h ' +
      paddedMinutes +
      'm ' +
      paddedSeconds +
      's'
    );
  }

  function formatDeliveryDate(timestamp) {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: DELIVERY_TIMEZONE,
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    }).format(new Date(timestamp));
  }

  function initDeliveryCountdown(root) {
    if (!root) {
      return;
    }

    /*
     * Prevent duplicate initialization.
     */
    if (root.dataset.deliveryInitialized === 'true') {
      return;
    }

    root.dataset.deliveryInitialized = 'true';

    const timerElement = root.querySelector(
      '[data-delivery-timer]'
    );

    const dateElement = root.querySelector(
      '[data-delivery-date]'
    );

    if (!timerElement || !dateElement) {
      return;
    }

    const deliveryDay = (
      root.dataset.deliveryDay || ''
    ).trim();

    if (!deliveryDay) {
      return;
    }

    const cutoffHour = Number(
      root.dataset.deliveryCutoffHour || 17
    );

    const cutoffMinute = Number(
      root.dataset.deliveryCutoffMinute || 0
    );

    let interval = null;

    function updateCountdown() {
      const deliveryDate = getNextDeliveryDate(
        deliveryDay,
        cutoffHour,
        cutoffMinute
      );

      /*
       * Invalid weekday entered in Shopify.
       */
      if (!deliveryDate) {
        timerElement.textContent = '';
        dateElement.textContent = deliveryDay;
        return;
      }

      const remaining =
        deliveryDate.timestamp - Date.now();

      /*
       * Update delivery date dynamically.
       * This means changing the Shopify metafield
       * will change the displayed delivery date.
       */
      dateElement.textContent =
        formatDeliveryDate(deliveryDate.timestamp);

      timerElement.textContent =
        formatCountdown(remaining);

      /*
       * If countdown reaches zero, immediately
       * recalculate the next delivery day.
       */
      if (remaining <= 0) {
        updateCountdown();
      }
    }

    updateCountdown();

    interval = window.setInterval(
      updateCountdown,
      1000
    );

    /*
     * Clean up when Shopify removes the section.
     */
    root._deliveryCountdownCleanup = function () {
      if (interval) {
        window.clearInterval(interval);
        interval = null;
      }

      delete root._deliveryCountdownCleanup;
    };
  }

  function initAllDeliveryCountdowns(scope) {
    const container = scope || document;

    const countdowns = container.querySelectorAll(
      '[data-delivery-countdown]'
    );

    countdowns.forEach(function (root) {
      initDeliveryCountdown(root);
    });
  }

  function cleanupDeliveryCountdowns(scope) {
    const container = scope || document;

    const countdowns = container.querySelectorAll(
      '[data-delivery-countdown]'
    );

    countdowns.forEach(function (root) {
      if (typeof root._deliveryCountdownCleanup === 'function') {
        root._deliveryCountdownCleanup();
      }
    });
  }

  /*
   * Initial page load
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAllDeliveryCountdowns(document);
      },
      { once: true }
    );
  } else {
    initAllDeliveryCountdowns(document);
  }

  /*
   * Shopify Theme Editor support
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAllDeliveryCountdowns(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      cleanupDeliveryCountdowns(event.target);
    }
  );
})();